import { render } from "./ConfirmRequest.vue?vue&type=template&id=72c3d9e0&scoped=true"
import script from "./ConfirmRequest.vue?vue&type=script&lang=js"
export * from "./ConfirmRequest.vue?vue&type=script&lang=js"

import "./ConfirmRequest.vue?vue&type=style&index=0&id=72c3d9e0&lang=scss&scoped=true"
import "./ConfirmRequest.vue?vue&type=style&index=1&id=72c3d9e0&lang=scss"

import exportComponent from "/Users/a/Desktop/app/pulizhenkong_pc/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-72c3d9e0"]])

export default __exports__